import type { FilterChip } from "../../types";
import { GlobalPresenceOption } from "@/components/filters/UserFilters/GlobalPresenceFilter/constants";
import { defaultGlobalPresenceSlice, type GlobalPresenceSlice } from "./slice";

function summarize(values: string[]): string {
  if (values.length <= 2) return values.join(", ");
  return `${values.slice(0, 2).join(", ")} +${values.length - 2}`;
}

export function getChips(
  slice: GlobalPresenceSlice,
  setSlice: (slice: GlobalPresenceSlice) => void
): FilterChip[] {
  if (slice.option === GlobalPresenceOption.NONE) return [];

  let label = "Global Presence: Multi-national";

  if (slice.option === GlobalPresenceOption.BY_LOCATION) {
    const parts: string[] = [];
    if (slice.hqValues.length > 0) {
      parts.push(`HQ in ${summarize(slice.hqValues)}`);
    }
    if (slice.subValues.length > 0) {
      parts.push(`Subs in ${summarize(slice.subValues)}`);
    }
    label =
      parts.length > 0
        ? `Global Presence: ${parts.join("; ")}`
        : "Global Presence: By location";
  }

  return [
    {
      id: "globalPresence",
      label,
      filterKey: "globalPresence" as const,
      onRemove: () => setSlice(defaultGlobalPresenceSlice),
    },
  ];
}

export function getCount(slice: GlobalPresenceSlice): number {
  return slice.option === GlobalPresenceOption.NONE ? 0 : 1;
}
